import React from 'react';

export const PostalCodeHint = () => (
  <div className="usa-hint schemaform-description">
    We ask for this information to send your question to the right place or
    provide relevant resources.
  </div>
);
